//Filter By only has these two types in legacy
export enum ReservesSearchSortType {
  Title = "Title",
  Author = "Author",
}